var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMtn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 1920 1280",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 1667,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M960 320c-353.46 0-640 143.27-640 320s286.54 320 640 320 640-143.27 640-320-286.54-320-640-320zm0 589.48c-325.56 0-589.48-120.65-589.48-269.48S634.44 370.52 960 370.52 1549.48 491.17 1549.48 640 1285.56 909.48 960 909.48zm-80.71-325.62v-50.53h180.55v50.53h-65v162.81H944.3V583.86zm398.49-50.53v213.34h-50.52l-91.63-127v127h-50.52V533.33h50.52l91.63 127v-127zM640.72 746.67V533.33h50.52l56.13 86.34 56.13-86.34H854v213.34h-50.5V626l-38.32 58.9h-35.62L691.24 626v120.67z",
    fill: "#ffcb05"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 1280c176.73 0 320-286.54 320-640S176.73 0 0 0M1920 0c-176.73 0-320 286.54-320 640s143.27 640 320 640M1600 1280c0-176.73-286.54-320-640-320s-640 143.27-640 320M320 0c0 176.73 286.54 320 640 320s640-143.27 640-320"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h1920v1280H0z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMtn);
export default __webpack_public_path__ + "static/media/mtn.6225cc2f2afa37dba865c569318c01b9.svg";
export { ForwardRef as ReactComponent };